module.exports = __webpack_public_path__ + "static/media/promocoes-selecionadas.baedf54d.jpg";